import { render } from "./privacy-policy.html?vue&type=template&id=32d233a3&ts=true&external"
import script from "./privacy-policy.ts?vue&type=script&lang=ts&external"
export * from "./privacy-policy.ts?vue&type=script&lang=ts&external"

import "./privacy-policy.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__